/**
 * Action & Interaction Icons
 * 
 * Icons for user actions like upload, download, copy, paste, delete, etc.
 * 
 * Used by: Buttons, action menus, toolbars
 */

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCloudArrowUp as fadCloudArrowUp,
  faCloudArrowDown as fadCloudArrowDown,
  faCloud as fadCloud,
  faUpload as fadUpload,
  faCopy as fadCopy,
  faPaperclip as fadPaperclip,
  faLink as fadLink,
  faLinkSimple as fadLinkSimple,
  faExternalLink as fadExternalLink,
  faTrashAlt as fadTrashAlt,
  faBroom as fadBroom,
  faPrint as fadPrint,
  faFloppyDiskPen as fadFloppyDiskPen,
  faPlusCircle as fadPlusCircle,
  faMinusCircle as fadMinusCircle,
  faSquarePlus as fadSquarePlus,
  faThumbsUp as fadThumbsUp,
  faThumbsDown as fadThumbsDown,
  faCirclePlay as fadCirclePlay,
  faCircleStop as fadCircleStop,
  faCirclePause as fadCirclePause,
  faVolumeHigh as fadVolumeHigh,
  faVolume as fadVolume,
  faVolumeSlash as fadVolumeSlash,
  faArrowCircleUp as fadArrowCircleUp,
  faLock as fadLock,
  faLockOpen as fadLockOpen,
  faKey as fadKey,
  faFingerprint as fadFingerprint,
  faShield as fadShield,
  faShieldCheck as fadShieldCheck,
  faShieldExclamation as fadShieldExclamation,
  faShieldXmark as fadShieldXmark,
  faShieldKeyhole as fadShieldKeyhole,
  faShieldHalved as fadShieldHalved,
  faPaintBrush as fadPaintBrush,
  faSquareEllipsisVertical as fadSquareEllipsisVertical,
  faCameraViewfinder as fadCameraViewfinder,
  faQrcode as fadQrcode,
  faTag as fadTag,
  faTags as fadTags,
  faHistory as fadHistory,
  faBadgeCheck as fadBadgeCheck,
  faWrench as fadWrench,
  faUnlock as fadUnlock,
  faHandsHelping as fadHandsHelping,
} from "@fortawesome/pro-duotone-svg-icons";

import {
  faArrowUpFromSquare as falArrowUpFromSquare,
  faSquarePlus as falSquarePlus,
  faDisplayArrowDown as falDisplayArrowDown,
} from "@fortawesome/pro-light-svg-icons";

import {
  faCloudArrowUp as fatCloudArrowUp,
} from "@fortawesome/pro-thin-svg-icons";

export const loadActionIcons = () => {
  // Duotone action icons
  library.add(
    fadCloudArrowUp,
    fadCloudArrowDown,
    fadCloud,
    fadUpload,
    fadCopy,
    fadPaperclip,
    fadLink,
    fadLinkSimple,
    fadExternalLink,
    fadTrashAlt,
    fadBroom,
    fadPrint,
    fadFloppyDiskPen,
    fadPlusCircle,
    fadMinusCircle,
    fadSquarePlus,
    fadThumbsUp,
    fadThumbsDown,
    fadCirclePlay,
    fadCircleStop,
    fadCirclePause,
    fadVolumeHigh,
    fadVolume,
    fadVolumeSlash,
    fadArrowCircleUp,
    fadLock,
    fadLockOpen,
    fadKey,
    fadFingerprint,
    fadShield,
    fadShieldCheck,
    fadShieldExclamation,
    fadShieldXmark,
    fadShieldKeyhole,
    fadShieldHalved,
    fadPaintBrush,
    fadSquareEllipsisVertical,
    fadCameraViewfinder,
    fadQrcode,
    fadTag,
    fadTags,
    fadHistory,
    fadBadgeCheck,
    fadWrench,
    fadUnlock,
    fadHandsHelping
  );

  // Light action icons
  library.add(
    falArrowUpFromSquare,
    falSquarePlus,
    falDisplayArrowDown,
  );

  // Thin action icons
  library.add(fatCloudArrowUp);
};
